<template>
	<div v-for="(room, index) in items" :key="room.pageID" class="room-block" :class="{ even: index % 2 == 0 }">
		<div class="row">
			<div class="columns column6 content">
				<h3>{{ room.header }}</h3>
				<div v-parse-links v-html="room.overviewContent" />
				<slot
					name="extraContent"
					:facilities="room.facilities"
					:filename="localePath(`/${room.filename}`)"
					:bookingid="room.bookingID"
				/>
			</div>
			<div class="image">
				<picture>
					<source v-if="room.overviewImageWebp" :srcset="room.overviewImageWebp" type="image/webp" />
					<source :srcset="room.overviewImage" />
					<img loading="lazy" :src="room.overviewImage" :alt="room.overviewImageAlt" />
				</picture>
			</div>
		</div>
	</div>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
});
const localePath = useLocalePath();
</script>

<style lang="scss" scoped>
.room-block {
	padding: 50px 20px;
	position: relative;
	background: var(--primary-background-color);

	.row {
		display: flex;
		flex-flow: row-reverse wrap;
		justify-content: space-between;
		align-items: center;
	}

	&.even {
		background: #fff;

		.row {
			flex-flow: row wrap;
		}
	}
}

.contentblock-image {
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	width: 58%;
	z-index: 1;
}

.content {
	padding: 50px 90px;
	margin: 0;
	position: relative;
	z-index: 2;

	.button {
		min-width: 210px;
		text-align: center;
		margin: 0 0 10px;
	}

	h3 {
		padding-bottom: 20px;
		margin: 0 0 10px;
		color: var(--body-color);
	}
}

.image {
	width: 50%;

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
}

@media (max-width: 1080px) {
	.image {
		width: 100%;
		position: relative;
		inset: auto;
	}

	.room-block,
	.room-block.even {
		padding: 50px 20px;

		.row {
			display: flex;
			flex-flow: wrap column-reverse;
		}
	}

	.content {
		margin: 0 auto;
		padding: 50px 30px 0;
	}
}
</style>
